module.exports = __webpack_public_path__ + "static/img/text.aa44636.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/text.png
// module id = ciHP
// module chunks = 6